import { Col, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import liracrypt from '../../components/Liracrypt/liracrypt';
import ApiErrorComp from '../../components/ApiErrorComp/ApiErrorComp';
import { LoadingOutlined } from '@ant-design/icons';
import LeftContainer from './LeftContainer';
import RightContainer from './RightContainer';
import RightIconContainer from './RightIcons';
import Header from './Hearder/Header';
import './linedashboard.css';
import LinePopup from './LinePopup';
import { connect } from 'mqtt/dist/mqtt';
import SpeechAudio from './SpeechAudio';
import RFIDModal from '../../components/RFIDModal';

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const MainDashboardZen = ({
    selectedLid,
    setSelectedLid
}) => {
    const [loading, setLoading] = useState(false);
    const [settings, setsettings] = useState(null);
    const [settingValues, setsettingValues] = useState(null);
    const [lineDetails, setlineDetails] = useState(null);
    const [compliance, setcompliance] = useState(null);
    const [loaded, setloaded] = useState(false);
    const [loginError, setloginError] = useState(false);
    const [variableData, setVariableData] = useState(null);

    const [target, setTarget] = useState(null);
    const [actual, setActual] = useState(null);
    const [difference, setDifference] = useState(null);
    const [rank, setRank] = useState(null);
    const [lineDashImageSrc, setlineDashImageSrc] = useState(null);
    const [dBlock, setDBlock] = useState(null);
    const [mini, setMini] = useState(null);
    const [mainG, setMainG] = useState(null);
    const [aux, setAux] = useState(null);

    const [lineLeaderModal, setLineLeaderModal] = useState(false);

    const [flipInterval, setFlipInterval] = useState(null);

    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
    const [refreshLineDashboard, setRefreshLineDashboard] = useState(0);

    const onRefreshLineDashboard = () => {
        setRefreshLineDashboard(refreshLineDashboard ? 0 : 1);
    };


    const setLineDashVariableData = (data) => {
        if (!data) return;
        setTarget(data["lD_ShiftPerf_Tgt"]);
        setActual(data["lD_ShiftPerf_Actual"]);
        setDifference(data["lD_ShiftPerf_Diff"]);
        setRank(data["lD_LineRank_Main"]);

        setMainG(data["lD_MainGauge"]);
        const temp = {};
        Object.keys(data).forEach((key) => {
            if (key.includes("lD_DataBlock")) {
                temp[key] = data[key];
            }
        });

        const gtemp = {};
        Object.keys(data).forEach((key) => {
            if (key.includes("lD_MicroGauge")) {
                gtemp[key] = data[key];
            }
        });

        setMini(gtemp);
        setDBlock(temp);
        setVariableData(data);
        setsettingValues(data);
    }

    const getLineDashData = () => {
        liracrypt
            .get("/linedash/linedashvariabledata", {
                lid: selectedLid,
                proj: "all",
            })
            .then(({ data }) => {
                setLineDashVariableData(data.data);
            })
            .catch(function (error) {
                if (error.response !== undefined) {
                    if (error.response.status !== 401) {
                        ApiErrorComp(error.response.status);
                    } else {
                        setloginError(true);
                    }
                }
            });
    };

    useEffect(() => {
        if (settings?.protocol === 'MQTT') {
            const client = connect(process.env.REACT_APP_MQTT_URL, {
                username: process.env.REACT_APP_MQTT_USER,
                password: process.env.REACT_APP_MQTT_PWD,
            });

            const _topic = "lid_001_linedashvariabledata_eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJleHAiOjE3ODc3NzcwMTIsInNjb2RlIjoiVEVTVDAwNEdRNVgiLCJpcCI6IjUyLjE3Mi4xODMuMTgiLCJ1c2VybmFtZSI6ImtyaXNoYW4iLCJyb2xlIjoiTGlyYUFkbWluIn0.qgb4WD1smo9OS6nVxX2bqt4nV0mifjXYOk3z74d6Q3VYKZkT8sGUF3HagLpUAzMkj8GmGBrpJE_0DgCphAJFpg"
            if (client) {
                client.on('connect', function (data) {
                    client.subscribe(_topic, (err, data) => {
                    })
                });

                client.on('message', (topic, message) => {
                    //  console.log(topic, message, 'mqtt')
                    setLineDashVariableData(JSON.parse(message.toString()));
                });
            }
        };
    }, [settings?.protocol]);

    useEffect(() => {
        getLineDashData();
        if (settings?.protocol === 'HTTP') {
            const inter = setInterval(() => {
                getLineDashData();
            }, 10000);
            return () => {
                clearInterval(inter);
            }
        };
    }, [selectedLid, refreshLineDashboard, settings?.protocol]);

    useEffect(() => {
        setLoading(true);
        Promise.all([
            liracrypt.get("/linedash/linedashuiconfig", {}),
            liracrypt.get("/linedash/linedashfixeddata", {
                lid: selectedLid,
            }),
            liracrypt.get("/linedashboard/compliance", {
                lid: selectedLid,
                proj: "compliance",
            }),
        ]).then(([lineDashLoad, lineDetails, compliance]) => {
            setcompliance(compliance.data.data["compliance"]);
            setlineDetails(lineDetails.data.config);
            setsettings(lineDashLoad.data.data);

            setlineDashImageSrc(lineDashLoad.data.data["imgSrc"]);
            setAux(lineDashLoad.data.data.auxMenu);
            setFlipInterval(
                lineDashLoad.data.data.ldDataBlockFlipInterval
                    ? lineDashLoad.data.data.ldDataBlockFlipInterval
                    : 8000
            );
            setloaded(true);
            setLoading(false);
            if (lineDashLoad.data.data?.identifyLineLeader === true) {
                setLineLeaderModal(true);
            }
        });

        return () => {
            //   clearInterval(inter);
        };
    }, [selectedLid, refreshLineDashboard]);

    return (
        <>
            {loading ?
                <div style={{
                    display: 'flex', justifyContent: 'center',
                    alignItems: 'center', width: '100%', height: '100vh'
                }}>
                    <Spin indicator={antIcon} />
                </div> :
                <div className='main-dashboard-zen'>
                    {settings !== null && settingValues !== null && loaded === true ?
                        <>
                            <Header
                                settings={settings}
                                settingValues={{
                                    settingValues,
                                    ld_PageTitle: lineDetails["ld_PageTitle"],
                                }}
                            />

                            <Row>
                                {
                                    mini ?
                                        <Col lg={11} md={24} sm={24} xs={24} className='left-container'>
                                            <LeftContainer
                                                refreshLineDashboard={onRefreshLineDashboard}
                                                lineDashImageSrc={lineDashImageSrc}
                                                lid={selectedLid}
                                                settings={settings}
                                                Actual={actual}
                                                Diff={difference}
                                                Target={target}
                                                Rank={rank}
                                                mini={mini}
                                                dBlock={dBlock}
                                                mainG={mainG}
                                                settingValues={{
                                                    ...settingValues,
                                                    ld_PartDet_pno: lineDetails["ld_PartDet_pno"],
                                                    ld_PartDet_Pname: lineDetails["ld_PartDet_Pname"],
                                                    ld_PartDet_Cust: lineDetails["ld_PartDet_Cust"],

                                                }}
                                            />
                                        </Col> : <></>
                                }

                                <Col lg={12} md={24} sm={24} xs={24} className='right-container'>
                                    <RightContainer
                                        settings={settings}
                                        lid={selectedLid}
                                        settingValues={{
                                            ...settingValues,
                                            ...lineDetails,
                                        }}
                                        dBlock={dBlock}
                                        selectedLid={selectedLid}
                                        mini={mini}
                                        flipInterval={flipInterval}
                                        aux={aux}
                                    />
                                </Col>
                                <Col lg={1} md={24} sm={24}>
                                    <RightIconContainer
                                        refreshLineDashboard={onRefreshLineDashboard}
                                        rightContainer={{
                                            andon: settings.ld_Andon,
                                            tabs: settings.ld_Tab_Main,
                                        }}
                                        selectedLid={selectedLid}
                                        compliance={compliance}
                                        aux={aux}
                                        settings={settings}
                                        setSelectedLid={setSelectedLid}
                                    />
                                </Col>
                            </Row>
                            <SpeechAudio selectedLid={selectedLid} />
                            {
                                settings?.auxFunctions?.popUpMsg?.enable ?
                                    <LinePopup auxFunctions={settings?.auxFunctions?.popUpMsg} selectedLid={selectedLid} refreshLineDashboard={onRefreshLineDashboard} /> : <></>
                            }
                            {
                                settings?.auxFunctions?.rfid?.enable ?
                                    <RFIDModal selectedLid={selectedLid} auxFunctions={settings?.auxFunctions?.rfid} /> : <></>
                            }
                        </> : <></>
                    }
                </div>}
        </>
    )
};

export default MainDashboardZen;